import * as React from 'react';
import { UserMenu, UserMenuProps, Logout, useGetIdentity } from 'react-admin';
import { MenuItem } from '@mui/material';
import { auth } from '../../firebase';

export const CustomUserMenu: React.FC<UserMenuProps> = props => {
  const { isLoading, data: identity } = useGetIdentity();
  const email = auth.currentUser?.email ?? identity?.fullName ?? 'No Email';

  return (
    <UserMenu {...props}>
      <MenuItem disabled>{isLoading ? 'Loading...' : email}</MenuItem>
      <Logout />
    </UserMenu>
  );
};
